import { MemberInterface, MemberInviteInterface, MemberPermission } from "@swivl-mono/types";
import { Dropdown, SelectableOption, Panel, Button, ButtonColor, ButtonSize } from "@swivl-mono/ui";
import RolesModel from "../../../../../Models/Roles/Roles.Model";
import { useMemo } from "react";
import MembersModel from "../../../../../Models/Member/Members.Model";
import { MemberPermissionsScopePanel } from "./MemberPermissionsScopePanel";
import { Member } from "../../../../../Models/Member/Member.Current";

interface Props {
  member?: MemberInterface;
  invite?: MemberInviteInterface;
  memberPermission: MemberPermission;
}

export function MemberOrInvitePermissionsRole(props: Props) {
  const { roles, parentRoles, rolesLoaded } = RolesModel.useState();
  const { memberPermission } = props;

  const memberOrInvite = props.member ? props.member! : props.invite!;

  const dropdownItems = useMemo(() => {

    if (Member.isInChildOrg) {
      const rolesArray = roles ? Object.values(roles) : []

      const parentRolesArray = parentRoles ? Object.values(parentRoles) : []

      let items: SelectableOption[] = []
      if (parentRolesArray && parentRolesArray.length > 0) {
        items.push({ label: "Default Roles", value: "default", isHeading: true })
        items.push(...parentRolesArray.map((role) => ({
          value: role.slug,
          label: role.name,
        })));
      }
      if (rolesArray && rolesArray.length > 0) {
        items.push({ label: "Custom Roles", value: "custom", isHeading: true })
        items.push(...rolesArray.map((role) => ({
          value: role.slug,
          label: role.name,
        })));
      }
      return items;
    } else {
      let items: SelectableOption[] = []
      const rolesArray = roles ? Object.values(roles) : []

      if (rolesArray && rolesArray.length > 0) {
        items.push(...rolesArray.map((role) => ({
          value: role.slug,
          label: role.name,
        })));
      }
      return items;
    }
  }, [rolesLoaded]);

  let selectedRole;
  if (rolesLoaded && memberPermission?.roleSlug) {
    if (roles && roles[memberPermission.roleSlug]) {
      selectedRole = roles[memberPermission.roleSlug]
    } else if (parentRoles && parentRoles[memberPermission.roleSlug]) {
      selectedRole = parentRoles[memberPermission.roleSlug]
    }
  }

  const updatePermissions = (updated: MemberPermission) => {
    if (props.member) {
      let member = { ...props.member };
      let permissionIndex = member.permissions.findIndex((permission) => permission.id === updated.id);
      member.permissions[permissionIndex] = updated;
      MembersModel.updateMember(member);

    } else if (props.invite) {
      let invite = { ...props.invite };

      let permissionIndex = invite.permissions.findIndex((permission) => permission.id === updated.id);
      invite.permissions[permissionIndex] = updated;

      MembersModel.updateInvite(invite);
    }
  }

  return <Panel className="mb-5">
    <div className="flex flex-row mb-1 items-center justify-center">
      <h4 className="m-0 flex-1">Role</h4>
      <Button size={ButtonSize.SMALL} color={ButtonColor.ORANGE}
        onClickAsync={async () => {
          if (window.confirm("Are you sure you want to remove this role?")) {
            if (props.member) {
              let member = { ...props.member };
              let permissionIndex = member.permissions.findIndex((permission) => permission.id === memberPermission.id);
              member.permissions.splice(permissionIndex, 1);
              await MembersModel.updateMember(member);
            } else if (props.invite) {
              let invite = { ...props.invite };
              let permissionIndex = invite.permissions.findIndex((permission) => permission.id === memberPermission.id);
              invite.permissions.splice(permissionIndex, 1);
              await MembersModel.updateInvite(invite);
            }
          }
        }}
      >
        REMOVE
      </Button>
    </div>

    <Dropdown
      options={dropdownItems}
      value={selectedRole?.slug}
      optionSelected={(option) => {
        let perms = { ...memberPermission };
        perms.roleSlug = option.value;
        updatePermissions(perms);
      }}
    />
    {selectedRole && <div className="mb-4"><i>{selectedRole.description}</i></div>}

    <h4>Locations</h4>
    <MemberPermissionsScopePanel
      memberOrInvite={memberOrInvite}
      memberPermission={memberPermission}
      updatePermissions={updatePermissions}
    />
  </Panel>
}